export default __webpack_public_path__ + "static/media/frame_move.e9f02728.svg";